import { ArtifactType, IntegrationSystem } from '@/shared/types';

import { IACUserRequest } from '@/modules/iac/types';

import { createArtifactRequestHeaders } from '@/helpers/createArtifactRequestHeaders';

import { SERVICE_CODES } from '@/lib/consts';

import { client } from '../../core/client';

import type { DocumentType, ResponseExtract, DataResponse, ResponseArtifact } from '../../types';

import { RMPSearchQueryParams } from './types';

export const iac = {
  search: (
    queryParams: RMPSearchQueryParams,
    headers?: Headers,
  ): Promise<ResponseExtract<IntegrationSystem.IAC> | string> => {
    return client.get(
      `/user-requests/${SERVICE_CODES.CRIMINAL_RECORD_SEARCH}/search?${new URLSearchParams(queryParams).toString()}`,
      { headers },
    );
  },
  getUserRequests: (purpose_id = ''): Promise<DataResponse<IACUserRequest[]>> => {
    return client.get(
      `/user-requests/external/${IntegrationSystem.IAC}?${new URLSearchParams(
        purpose_id ? { purpose_id } : '',
      ).toString()}`,
    );
  },
  downloadUserRequestArtifact: (requestId: string, artifactType: ArtifactType): Promise<ResponseArtifact> => {
    return client.get(`/artifacts/${IntegrationSystem.IAC}/${artifactType}/${requestId}`, {
      headers: createArtifactRequestHeaders(artifactType),
    });
  },
  canBeDeliveredToAddress: (): Promise<DataResponse<Record<'answer', boolean>>> => {
    return client.get(`/user-requests/${SERVICE_CODES.EXTENDED_CRIMINAL_RECORD_EXTRACT}/canBeDeliveredToAddress`);
  },
  dictionary: {
    getDocumentTypes: (): Promise<DataResponse<Array<DocumentType<IntegrationSystem.IAC>>>> => {
      return client.get(`/referenceBook/${IntegrationSystem.IAC}/getPersonalDocuments`);
    },
  },
};
